import React, { useEffect } from 'react';
import { TabView, CustomChip } from '../../../../Core/Controls';
import VehicleDashBoard from './vehicleDash';
import NoteDashboard from './../Notes/index';
import DefectScreen from '../../Maintenance/Defects/defectScreen';
import BreakDownDashboard from '../../Maintenance/BreakDown/breakDownDashboard';
import ScheduleDashboard from './ScheduleVehicle/scheduleVehicle';
import JobScreen from '../JOBS/JobScreen';
import VehicleJourneys from './VehicleJourneys';
import FuelPurchaseDashboard from './../FuelPurchaseTab';
import DriverDailyChecksGrid from './DriverDailyChecks';
import BuildIcon from '@material-ui/icons/Build';
import DefaultMesaage from './Message/index';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import MileageLog from '../MileageLog/mileageLog';
import { useState } from 'react';
import VorScreen from '../VOR/VorIndex';
import { getTitleData } from '../../../../Core/Services/InternalUser/ControllerService/vehicleService';
import { useLoader } from '../../../../Core/Hooks/useLoader';
import AddVor from '../VOR/AddEditVor';
import InvoiceScreen from '../../Invoices';
import DialogComp from '../../../../Core/Dialog/DialogComp';
import ScheduleCalender from '../../../ServiceAgent/Schedules/ScheduleDashboard';
import ContractDash from '../Vehicles/Contract/index';
import VehicleRecalls from './VehicleRecall/index';
import SalesInvoiceScreen from '../../Invoices/salesInvoice';
import { AppStorage } from '../../../../Core/Basic/storage-service';
import { useLoginInfo } from '../../../../Core/Hooks/useLoginInfo';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import PenaltyCharges from './PenaltyCharges';

export default function EditVehicle(props) {
    let checkhaveAccess = AppStorage.getAllowAcces();
    const { userRoles } = useLoginInfo();
    const isCustomer = userRoles.includes('customer');
    const id = props?.match?.params?.id;
    // const id = props?.match?.params?.id;
    // const VID = props?.match?.params?.id;
    console.log(id, 'vid');
    const serviceAgentid = props?.match?.params.serviceAgentid;
    const history = useHistory();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const isRedirectLabel = searchParams.get('redirectLabel');

    const { showLoader, hideLoader } = useLoader();

    const [tabIndex, setTabIndex] = useState(undefined);
    const [state, setState] = useState({
        desc: '',
        vorID: null,
        loader: true,
        regNumber: '',
        vehiclePrimaryServiceAgentID: null,
        vehicleContractID: null
    });
    const selectTabIndex = (label) => {
        let tabs = newTabs();
        const index = tabs.findIndex((tab) => tab.label === label);
        if (index != -1) {
            var d = new Date();
            var n = d.getTime();
            setState((st) => ({ ...st, timeDependency: n }));
            const searchParams = new URLSearchParams(location.search);
            searchParams.delete('redirectLabel');
            searchParams.delete('isReset');
            searchParams.set('tab_testing_tabs', index);
            history.replace({ search: searchParams.toString() });
            setTabIndex(index);
        }
    };

    useEffect(() => {
        if (isRedirectLabel) {
            selectTabIndex(isRedirectLabel);
        }
    }, [state.vehicleContractID, isRedirectLabel]);

    const pullDetails = async () => {
        showLoader();
        let res = await getTitleData(id);
        if (res.success) {
            let data = res.data.details[0];
            setState((st) => ({
                ...st,
                desc: data?.vehicleDescription,
                vorID: data?.vorVehicleID,
                loader: false,
                vehicleContractID: data.vehicleContractID,
                regNumber: data?.vehicleDescription.split('-')[0].trim(),
                vehiclePrimaryServiceAgentID: data?.vehiclePrimaryServiceAgentID
            }));
            hideLoader();
        } else {
            hideLoader();
        }
    };

    const closeAddPopUp = (flag, name) => {
        setState((st) => ({ ...st, showVORPopup: false }));
        flag && pullDetails();
    };

    const handleAddPopUp = () => {
        setState((st) => ({ ...st, showVORPopup: true }));
    };

    const tabs = [
        {
            label: 'Dashboard',
            body: <VehicleDashBoard VehicleID={id} changeIndex={selectTabIndex} pullDetails={pullDetails} vorID={state.vorID} vehicleDisc={state.desc} />
        },
        {
            label: 'Breakdowns',
            body: <BreakDownDashboard frompage="Vehicles" VehicleID={id} fromTab={true} />
        },
        {
            label: 'Defects',
            body: <DefectScreen VehicleID={id} frompage="Vehicles" fromTab={true} pullDetails={pullDetails} />
        },
        {
            label: 'VOR',
            body: <VorScreen VehicleID={id} frompage="Vehicles" fromTab={true} />
        },
        {
            label: 'Calendar',
            body: <ScheduleCalender scheduleVehicleID={id} fromTab={true} serviceAgentid={state.vehiclePrimaryServiceAgentID} />
        },
        {
            label: 'Schedules',
            body: <ScheduleDashboard scheduleVehicleID={id} fromTab={true} serviceAgentid={state.vehiclePrimaryServiceAgentID} vehicleDisc={state.desc} />
        },
        // {
        //     label: 'Estimates',
        //     body: <h1>Estimates Screen</h1>
        // },

        {
            label: 'Jobs',
            body: (
                <>
                    <JobScreen VehicleID={id} frompage="JOBS" fromTab={true} />
                </>
            )
        },
        ...(checkhaveAccess?.CanViewInvoices
            ? [
                  ...(!isCustomer
                      ? [
                            {
                                label: 'Purchase Invoices',
                                body: <InvoiceScreen VehicleID={id} ServiceAgentID={state.vehiclePrimaryServiceAgentID} />
                            }
                        ]
                      : []),
                  {
                      label: 'Sales Invoices',
                      body: <SalesInvoiceScreen VehicleID={id} ServiceAgentID={state.vehiclePrimaryServiceAgentID} />
                  }
              ]
            : []),
        { label: 'Mileage', body: <MileageLog VehicleID={id} /> },
        ...(checkhaveAccess?.CanViewNotes
            ? [
                  {
                      label: 'Notes',
                      body: <NoteDashboard frompage="Vehicles" NoteVehicleID={id} />
                  }
              ]
            : []),
        {
            label: 'Journeys',
            body: <VehicleJourneys VehicleID={id} frompage="Journeys" />
        },

        {
            label: 'Checks',
            body: <DriverDailyChecksGrid VehicleID={id} frompage="Checks" fromTab={true} />
        },
        {
            label: 'Recalls',
            body: <VehicleRecalls VehicleID={id} frompage="Checks" fromTab={true} vehicleDesc={state.desc} />
        },
        { label: 'Fuel', body: <FuelPurchaseDashboard VehicleID={id} /> },
        {
            label: 'Messages',
            body: <DefaultMesaage VehicleID={id} frompage="Message" fromTab={true} />
        },
        {
            label: 'Contract',
            body: <ContractDash VehicleID={id} frompage="Contract" vehicleContractID={state.vehicleContractID} fromTab={true} pullDetails={pullDetails} />
        },
        {
            label: 'Penalty Charges',
            body: <PenaltyCharges VehicleID={id} frompage="PenaltyCharges" pullDetails={pullDetails} regNumber={state.regNumber} />
        }
    ];
    let newTabs = () => {
        let newTabs = [...tabs];
        if (!checkhaveAccess?.CanViewBreakdowns) {
            let index = newTabs.findIndex((m) => m.label === 'Breakdowns');
            newTabs.splice(index, 1);
        }
        if (!checkhaveAccess?.CanViewDefects) {
            let index = newTabs.findIndex((m) => m.label === 'Defects');
            newTabs.splice(index, 1);
        }
        if (!checkhaveAccess?.CanViewDailyChecks) {
            let index = newTabs.findIndex((m) => m.label === 'Checks');
            newTabs.splice(index, 1);
        }
        if (!checkhaveAccess?.CanViewSchedules) {
            let index = newTabs.findIndex((m) => m.label === 'Schedules');
            newTabs.splice(index, 1);
        }
        if (!checkhaveAccess?.CanViewJobs) {
            let index = newTabs.findIndex((m) => m.label === 'Jobs');
            newTabs.splice(index, 1);
        }
        if (!checkhaveAccess?.CanViewMessages) {
            let index = newTabs.findIndex((m) => m.label === 'Messages');
            newTabs.splice(index, 1);
        }
        if (!checkhaveAccess?.CanViewSalesInvoices) {
            let index = newTabs.findIndex((m) => m.label === 'Sales Invoices');
            newTabs.splice(index, 1);
        }
        if (!checkhaveAccess?.CanViewVOR) {
            let index = newTabs.findIndex((m) => m.label === 'VOR');
            newTabs.splice(index, 1);
        }

        return newTabs;
    };

    useEffect(async () => {
        pullDetails();
    }, [id]);

    return (
        <div className="screen">
            <Grid container spacing={1}>
                <Grid item>
                    <Typography variant="h5">{state.desc?.toUpperCase() || ''}</Typography>
                </Grid>
                {state.vorID && (
                    <Grid item>
                        <CustomChip color="secondary" className="btn-m" icon={BuildIcon} label="VOR" onClick={handleAddPopUp} />
                        {/* <CustomChip icon={EditIcon} label="Update VOR" onClick={() => handleAddPopUp(data.VehicleID, 'showVORPopup')} className="btn-m" /> */}
                    </Grid>
                )}
            </Grid>
            <TabView tabList={newTabs()} id="testing_tabs" selectedIndex={tabIndex} timeDependency={state.timeDependency} />
            {state.showVORPopup ? (
                <DialogComp
                    title={`${state.vorID ? 'Update' : 'Add'} VOR - ${state.regNumber}`}
                    onClose={() => closeAddPopUp(false)}
                    maxWidth="lg"
                    overflow="auto"
                    fullScreen
                >
                    <AddVor VehicleID={id} update={state.vorID} vorVehicleID={state.vorID} onClose={closeAddPopUp} />
                </DialogComp>
            ) : null}
        </div>
    );
}
